<template>
  <v-container id="bid-paperwork" fluid tag="section" class="main-container">
    <idc-component-bid-paperwork
      :settings="settings"
      :can-edit="canEditLivePaperwork"
      :can-read="canRead"
      :can-delete="canEditLivePaperwork"
      :url-specification="urlSpecification"
    />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import Path from '@/utilities/bid/enums/Path'

  export default Vue.extend({
    name: 'DashboardBidPaperwork',
    components: {
      IdcComponentBidPaperwork: () => import('@/components/idc/bids/Paperwork'),
    },
    props: {
      canRead: {
        type: Boolean,
        default: () => true,
      },
      canEditLivePaperwork: {
        type: Boolean,
        default: () => false,
      },
      urlSpecification: {
        type: String,
        default: () => Path.PROJECTS_SPEC,
      },
      urlSummary: {
        type: String,
        default: () => Path.PROJECTS_SUMMARY,
      },
    },
    computed: {
      ...mapState('Settings', ['settings']),
    },
  })
</script>
